import { render, staticRenderFns } from "./tih.vue?vue&type=template&id=158a3348&scoped=true&"
import script from "./tih.vue?vue&type=script&lang=js&"
export * from "./tih.vue?vue&type=script&lang=js&"
import style0 from "./tih.vue?vue&type=style&index=0&id=158a3348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a3348",
  null
  
)

export default component.exports